"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ESTIMATED_GAS = exports.NATIVE_GAS_TOKEN_SYMBOL = void 0;
const types_1 = require("../../types");
exports.NATIVE_GAS_TOKEN_SYMBOL = {
    [types_1.EvmChain.AVALANCHE]: types_1.GasToken.AVAX,
    [types_1.EvmChain.MOONBEAM]: types_1.GasToken.GLMR,
    [types_1.EvmChain.POLYGON]: types_1.GasToken.MATIC,
    [types_1.EvmChain.ETHEREUM]: types_1.GasToken.ETH,
    [types_1.EvmChain.FANTOM]: types_1.GasToken.FTM,
    [types_1.EvmChain.AURORA]: types_1.GasToken.AURORA,
    [types_1.EvmChain.BINANCE]: types_1.GasToken.BINANCE,
    [types_1.EvmChain.BNBCHAIN]: types_1.GasToken.BNBCHAIN,
    [types_1.EvmChain.ARBITRUM]: types_1.GasToken.ETH,
    [types_1.EvmChain.CELO]: types_1.GasToken.CELO,
    [types_1.EvmChain.KAVA]: types_1.GasToken.KAVA,
    [types_1.EvmChain.BASE]: types_1.GasToken.BASE,
    [types_1.EvmChain.FILECOIN]: types_1.GasToken.FILECOIN,
    [types_1.EvmChain.OPTIMISM]: types_1.GasToken.ETH,
    [types_1.EvmChain.LINEA]: types_1.GasToken.ETH,
    [types_1.EvmChain.POLYGON_ZKEVM]: types_1.GasToken.POLYGON_ZKEVM,
    [types_1.EvmChain.MANTLE]: types_1.GasToken.MANTLE,
};
exports.DEFAULT_ESTIMATED_GAS = 700000;
//# sourceMappingURL=contract.js.map